export default __webpack_public_path__ + "static/media/sammy.99b70568.png";